import Grid from '@mui/material/Grid';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ExecutionBlock from './ExecutionBlock';
import Pod from '../Shared/Pod';
import Title from '../Shared/Title';
import { useSelector } from 'react-redux';
import options from '../Config/options';

const ExecutionDetailRow = props => {
    const sysconfig = useSelector(state => state.sysconfig);

    let output = props.step.Output || []
    output = Array.isArray(output) ? output : [output]

    const system = props.step.Input[props.node].system

    const rowcount = (
        props.node === "target" ? output : output.map(x => (x?.records || []).filter(y => y !== null) || {}).flat()
    ).reduce((n, { row_count }) => n + (row_count || 0), 0)
    // const rowcount = 0
    // const output = []

    return (
        <Grid container
            sx={{ borderTop: '1px dotted #ccc', py: 1 }}
        >
            <Grid item xs={2}>
                {props.step.Input.records.map((record, key) => {
                    const schema = props.schemas ? props.schemas.find(x => x.SystemKey === system && x.Name === record.object) || {} : {}
                    return (
                        <Grid container key={key} sx={{ py: 0.25 }}>
                            <Pod>
                                <Title
                                    row
                                    href={schema?.Id ? `/schemas/${schema.Id}` : '#'}
                                    systems={[system]}
                                    label={record.object}
                                />
                            </Pod>
                            {record.params && record.params.map((param, key) => (
                                <Grid container
                                    key={key}
                                    className="ExecutionParam"
                                >
                                    <KeyboardArrowRightIcon />
                                    {param.field}
                                    {options.operator.find(o => o.value === param.operator)?.label}
                                    {param.value}
                                </Grid>
                            ))}
                           {record.object_key && <Grid container className="ExecutionParam">
                                <InsertDriveFileOutlinedIcon />
                                {record.object_key}
                            </Grid>}
                        </Grid>
                    )
                })}

            </Grid>
            <Grid item xs={9}>
                <ExecutionBlock item={props.step} maxWidth={props.maxWidth} date={props.date} />
            </Grid>
            <Grid item xs={1} sx={{}}>
                {rowcount} rows
            </Grid>
        </Grid>
    )
}
export default ExecutionDetailRow;